export default function Warning({message,closeWarning}){
    const closePopup=()=>{
        let exit=false;
        if(message=='MSG'){
            exit=true;
        }
        closeWarning(exit);
    }
    return (
        <div className="dialogcls" style={{gap:'10px'}}>
            <img src="/error.png" />
            <span style={{fontWeight:'700'}}>{message=='MSG'?'Server error ,please try again':message}</span>
            <button style={{width:'90%',backgroundColor:'#003366',padding:'10px',color:'white'}} onClick={()=>closePopup()}>OK</button>
        </div>
    )
}